import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { setRangeValue } from "../../Utils/NumberUtils";
export var AnimationOptions = /*#__PURE__*/function () {
  function AnimationOptions() {
    _classCallCheck(this, AnimationOptions);

    this.count = 0;
    this.enable = false;
    this.speed = 1;
    this.decay = 0;
    this.delay = 0;
    this.sync = false;
  }

  _createClass(AnimationOptions, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      if (data.count !== undefined) {
        this.count = setRangeValue(data.count);
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      if (data.speed !== undefined) {
        this.speed = setRangeValue(data.speed);
      }

      if (data.decay !== undefined) {
        this.decay = setRangeValue(data.decay);
      }

      if (data.delay !== undefined) {
        this.delay = setRangeValue(data.delay);
      }

      if (data.sync !== undefined) {
        this.sync = data.sync;
      }
    }
  }]);

  return AnimationOptions;
}();
export var RangedAnimationOptions = /*#__PURE__*/function (_AnimationOptions) {
  _inherits(RangedAnimationOptions, _AnimationOptions);

  var _super = _createSuper(RangedAnimationOptions);

  function RangedAnimationOptions() {
    var _this;

    _classCallCheck(this, RangedAnimationOptions);

    _this = _super.call(this);
    _this.mode = "auto";
    _this.startValue = "random";
    return _this;
  }

  _createClass(RangedAnimationOptions, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(RangedAnimationOptions.prototype), "load", this).call(this, data);

      if (!data) {
        return;
      }

      if (data.minimumValue !== undefined) {
        this.minimumValue = data.minimumValue;
      }

      if (data.mode !== undefined) {
        this.mode = data.mode;
      }

      if (data.startValue !== undefined) {
        this.startValue = data.startValue;
      }
    }
  }]);

  return RangedAnimationOptions;
}(AnimationOptions);